export const noticias1 = [
  {
    id: 0,
    palavra: 'TEMOR',
    classe: 'temor',
    manchete: 'Não há motivo para temor...',
    descricao:
      'Diz Moro sobre novo coronavírus em prisões. Ministro diz que ainda não há registros da infecção entre detentos',
    link: 'https://agenciabrasil.ebc.com.br/justica/noticia/2020-03/nao-ha-motivo-para-temor-diz-moro-sobre-coronavirus-em-presidios',
    data: '31/03/2020',
  },
  {
    id: 1,
    palavra: 'MORO',
    classe: 'moro',
    manchete: 'Não há motivo para temor...',
    descricao:
      'Diz Moro sobre novo coronavírus em prisões. Ministro diz que ainda não há registros da infecção entre detentos',
    link: 'https://agenciabrasil.ebc.com.br/justica/noticia/2020-03/nao-ha-motivo-para-temor-diz-moro-sobre-coronavirus-em-presidios',
    data: '31/03/2020',
  },
  {
    id: 2,
    palavra: 'Lewandowski',
    classe: 'lewandowski',
    manchete: 'Lewandowski dá 48h para que presídios informem sobre medidas contra coronavírus',
    descricao: 'Ministro do STF negou soltura de presas mães e gestantes por conta da pandemia',
    link: 'https://www.jota.info/stf/do-supremo/lewandowski-da-48h-para-que-presidios-informem-sobre-medidas-contra-coronavirus-23032020',
    data: '23/03/2020',
  },
  {
    id: 3,
    palavra: 'Lewandowski',
    classe: 'lewandowski-2',
    manchete: 'Lewandowski dá 48h para que presídios informem sobre medidas contra coronavírus',
    descricao: 'Ministro do STF negou soltura de presas mães e gestantes por conta da pandemia',
    link: 'https://www.jota.info/stf/do-supremo/lewandowski-da-48h-para-que-presidios-informem-sobre-medidas-contra-coronavirus-23032020',
    data: '23/03/2020',
  },
  {
    id: 4,
    palavra: 'negou soltura',
    classe: 'negou-soltura',
    manchete: 'Lewandowski dá 48h para que presídios informem sobre medidas contra coronavírus',
    descricao: 'Ministro do STF negou soltura de presas mães e gestantes por conta da pandemia',
    link: 'https://www.jota.info/stf/do-supremo/lewandowski-da-48h-para-que-presidios-informem-sobre-medidas-contra-coronavirus-23032020',
    data: '23/03/2020',
  },
  {
    id: 5,
    palavra: 'STF derruba',
    classe: 'stf-derruba',
    manchete: 'STF derruba liminar que sugeriu soltar presos por conta do Covid-19',
    descricao: 'Vara deve analisar caso de cada preso antes de liberdade provisória',
    link: 'https://agenciabrasil.ebc.com.br/justica/noticia/2020-03/STF-derruba-liminar-que-sugeriu-soltar-presos-por-conta-do-COVID-19',
    data: '18/03/2020',
  },
  {
    id: 6,
    palavra: 'STF derruba',
    classe: 'stf-derruba-2',
    manchete: 'STF derruba liminar que sugeriu soltar presos por conta do Covid-19',
    descricao: 'Vara deve analisar caso de cada preso antes de liberdade provisória',
    link: 'https://agenciabrasil.ebc.com.br/justica/noticia/2020-03/STF-derruba-liminar-que-sugeriu-soltar-presos-por-conta-do-COVID-19',
    data: '18/03/2020',
  },
  {
    id: 7,
    palavra: 'liberdade provisória',
    classe: 'liberdade-provisoria',
    manchete: 'STF derruba liminar que sugeriu soltar presos por conta do Covid-19',
    descricao: 'Vara deve analisar caso de cada preso antes de liberdade provisória',
    link: 'https://agenciabrasil.ebc.com.br/justica/noticia/2020-03/STF-derruba-liminar-que-sugeriu-soltar-presos-por-conta-do-COVID-19',
    data: '18/03/2020',
  },
  {
    id: 8,
    palavra: 'fux',
    classe: 'fux',
    manchete: 'Saída de presos pelo coronavírus pode gerar crise sem precedentes, diz Fux',
    descricao:
      'Ministro do STF lembra que o Conselho Nacional de Justiça "recomendou" e não "determinou" a liberação dos presos em regime semiaberto',
    link: 'https://exame.com/brasil/saida-de-presos-pelo-coronavirus-pode-gerar-crise-sem-precedentes-diz-fux/',
    data: '05/04/2020',
  },
  {
    id: 9,
    palavra: 'fux',
    classe: 'fux-2',
    manchete: 'Saída de presos pelo coronavírus pode gerar crise sem precedentes, diz Fux',
    descricao:
      'Ministro do STF lembra que o Conselho Nacional de Justiça "recomendou" e não "determinou" a liberação dos presos em regime semiaberto',
    link: 'https://exame.com/brasil/saida-de-presos-pelo-coronavirus-pode-gerar-crise-sem-precedentes-diz-fux/',
    data: '05/04/2020',
  },
  {
    id: 10,
    palavra: 'Conselho Nacional de Justiça',
    classe: 'conselho-nacional-de-justica',
    manchete: 'Saída de presos pelo coronavírus pode gerar crise sem precedentes, diz Fux',
    descricao:
      'Ministro do STF lembra que o Conselho Nacional de Justiça "recomendou" e não "determinou" a liberação dos presos em regime semiaberto',
    link: 'https://exame.com/brasil/saida-de-presos-pelo-coronavirus-pode-gerar-crise-sem-precedentes-diz-fux/',
    data: '05/04/2020',
  },
  {
    id: 11,
    palavra: 'Conselho Nacional de Justiça',
    classe: 'conselho-nacional-de-justica-2',
    manchete: 'Saída de presos pelo coronavírus pode gerar crise sem precedentes, diz Fux',
    descricao:
      'Ministro do STF lembra que o Conselho Nacional de Justiça "recomendou" e não "determinou" a liberação dos presos em regime semiaberto',
    link: 'https://exame.com/brasil/saida-de-presos-pelo-coronavirus-pode-gerar-crise-sem-precedentes-diz-fux/',
    data: '05/04/2020',
  },
  {
    id: 12,
    palavra: 'Conselho Nacional de Justiça',
    classe: 'conselho-nacional-de-justica-3',
    manchete: 'Saída de presos pelo coronavírus pode gerar crise sem precedentes, diz Fux',
    descricao:
      'Ministro do STF lembra que o Conselho Nacional de Justiça "recomendou" e não "determinou" a liberação dos presos em regime semiaberto',
    link: 'https://exame.com/brasil/saida-de-presos-pelo-coronavirus-pode-gerar-crise-sem-precedentes-diz-fux/',
    data: '05/04/2020',
  },
  {
    id: 13,
    palavra: 'Assustou',
    classe: 'assustou',
    manchete: 'O que pensam os juízes que estão soltando presos em meio à pandemia',
    descricao:
      'O anúncio do Depen de que 30 mil presos foram beneficiados por recomendação do Conselho Nacional da Justiça assustou parte da população, mas juízes ouvidos pela Pública levam em conta os riscos para sociedade e para a saúde coletiva.',
    link: 'https://apublica.org/2020/04/o-que-pensam-os-juizes-que-estao-soltando-presos-em-meio-a-pandemia/',
    data: '07/04/2020',
  },
  {
    id: 14,
    palavra: 'População',
    classe: 'populacao',
    manchete: 'O que pensam os juízes que estão soltando presos em meio à pandemia',
    descricao:
      'O anúncio do Depen de que 30 mil presos foram beneficiados por recomendação do Conselho Nacional da Justiça assustou parte da população, mas juízes ouvidos pela Pública levam em conta os riscos para sociedade e para a saúde coletiva.',
    link: 'https://apublica.org/2020/04/o-que-pensam-os-juizes-que-estao-soltando-presos-em-meio-a-pandemia/',
    data: '07/04/2020',
  },
  {
    id: 15,
    palavra: 'Moro',
    classe: 'moro2',
    manchete: '25 mil presos são soltos por causa do coronavírus. Moro pede moderação aos juízes.',
    descricao:
      'A medida é criticada pelo ministro da Justiça e Segurança Pública, Sergio Moro, mas tem respaldo no Conselho Nacional de Justiça (CNJ), presidido pelo presidente do Supremo Tribunal Federal (STF), Dias Toffoli.',
    link: 'https://www.gazetadopovo.com.br/republica/soltura-presos-coronavirus-moro-critica/',
    data: '09/04/2020',
  },
  {
    id: 16,
    palavra: 'Moro',
    classe: 'moro-3',
    manchete: '25 mil presos são soltos por causa do coronavírus. Moro pede moderação aos juízes.',
    descricao:
      'A medida é criticada pelo ministro da Justiça e Segurança Pública, Sergio Moro, mas tem respaldo no Conselho Nacional de Justiça (CNJ), presidido pelo presidente do Supremo Tribunal Federal (STF), Dias Toffoli.',
    link: 'https://www.gazetadopovo.com.br/republica/soltura-presos-coronavirus-moro-critica/',
    data: '09/04/2020',
  },
  {
    id: 17,
    palavra: 'Moderação',
    classe: 'moderacao',
    manchete: '25 mil presos são soltos por causa do coronavírus. Moro pede moderação aos juízes.',
    descricao:
      'A medida é criticada pelo ministro da Justiça e Segurança Pública, Sergio Moro, mas tem respaldo no Conselho Nacional de Justiça (CNJ), presidido pelo presidente do Supremo Tribunal Federal (STF), Dias Toffoli.',
    link: 'https://www.gazetadopovo.com.br/republica/soltura-presos-coronavirus-moro-critica/',
    data: '09/04/2020',
  },
  {
    id: 18,
    palavra: 'Moderação',
    classe: 'moderacao-2',
    manchete: '25 mil presos são soltos por causa do coronavírus. Moro pede moderação aos juízes.',
    descricao:
      'A medida é criticada pelo ministro da Justiça e Segurança Pública, Sergio Moro, mas tem respaldo no Conselho Nacional de Justiça (CNJ), presidido pelo presidente do Supremo Tribunal Federal (STF), Dias Toffoli.',
    link: 'https://www.gazetadopovo.com.br/republica/soltura-presos-coronavirus-moro-critica/',
    data: '09/04/2020',
  },
  {
    id: 19,
    palavra: 'Coronavírus não é Habeas Corpus',
    classe: 'coronavirus-nao-e-habeas-corpus',
    manchete: 'Coronavírus não é Habeas Corpus',
    descricao: 'Dose de recomendações humanitárias não podem ser remédio que mate a sociedade e seus valores',
    link: 'https://opiniao.estadao.com.br/noticias/espaco-aberto,coronavirus-nao-e-habeas-corpus,70003266658',
    data: '10/04/2020',
  },
  {
    id: 20,
    palavra: 'Coronavírus não é Habeas Corpus',
    classe: 'coronavirus-nao-e-habeas-corpus-2',
    manchete: 'Coronavírus não é Habeas Corpus',
    descricao: 'Dose de recomendações humanitárias não podem ser remédio que mate a sociedade e seus valores',
    link: 'https://opiniao.estadao.com.br/noticias/espaco-aberto,coronavirus-nao-e-habeas-corpus,70003266658',
    data: '10/04/2020',
  },
  {
    id: 21,
    palavra: 'Coronavírus não é Habeas Corpus',
    classe: 'coronavirus-nao-e-habeas-corpus-3',
    manchete: 'Coronavírus não é Habeas Corpus',
    descricao: 'Dose de recomendações humanitárias não podem ser remédio que mate a sociedade e seus valores',
    link: 'https://opiniao.estadao.com.br/noticias/espaco-aberto,coronavirus-nao-e-habeas-corpus,70003266658',
    data: '10/04/2020',
  },
  {
    id: 22,
    palavra: 'Prisão domiciliar',
    classe: 'prisao-domiciliar',
    manchete: 'Defensores contestam declarações de Moro por presos na crise da Covid-19',
    descricao:
      'Conselho Nacional de Justiça recomenda aos magistrados, entre outras medidas, prisão domiciliar para detentos de menor periculosidade',
    data: '11/04/2020',
    link: 'https://valor.globo.com/politica/noticia/2020/04/11/defensores-contestam-declaracoes-de-moro-por-presos-na-crise-da-covid-19.ghtml',
  },
  {
    id: 23,
    palavra: 'menor periculosidade',
    classe: 'menor-periculosidade',
    manchete: 'Defensores contestam declarações de Moro por presos na crise da Covid-19',
    descricao:
      'Conselho Nacional de Justiça recomenda aos magistrados, entre outras medidas, prisão domiciliar para detentos de menor periculosidade',
    data: '11/04/2020',
    link: 'https://valor.globo.com/politica/noticia/2020/04/11/defensores-contestam-declaracoes-de-moro-por-presos-na-crise-da-covid-19.ghtml',
  },
  {
    id: 24,
    palavra: 'menor periculosidade',
    classe: 'menor-periculosidade-2',
    manchete: 'Defensores contestam declarações de Moro por presos na crise da Covid-19',
    descricao:
      'Conselho Nacional de Justiça recomenda aos magistrados, entre outras medidas, prisão domiciliar para detentos de menor periculosidade',
    data: '11/04/2020',
    link: 'https://valor.globo.com/politica/noticia/2020/04/11/defensores-contestam-declaracoes-de-moro-por-presos-na-crise-da-covid-19.ghtml',
  },
  {
    id: 25,
    palavra: 'menor periculosidade',
    classe: 'menor-periculosidade-3',
    manchete: 'Defensores contestam declarações de Moro por presos na crise da Covid-19',
    descricao:
      'Conselho Nacional de Justiça recomenda aos magistrados, entre outras medidas, prisão domiciliar para detentos de menor periculosidade',
    data: '11/04/2020',
    link: 'https://valor.globo.com/politica/noticia/2020/04/11/defensores-contestam-declaracoes-de-moro-por-presos-na-crise-da-covid-19.ghtml',
  },
]

export const noticias2 = [
  {
    id: 0,
    palavra: 'Amor',
    classe: 'amor',
    manchete: '“Apavorado”: com o risco da Covid, presos enviam cartas de amor e despedida',
    image: require('@/assets/images/cartas1.jpeg'),
    descricao: '',
    data: '30/04/2020',
    link: 'https://www.geledes.org.br/apavorado-com--o-risco-da-covid-presos-enviam-cartas-de-amor-e-despedida/',
  },
  {
    id: 1,
    palavra: 'despedida',
    classe: 'despedida',
    manchete: '“Apavorado”: com o risco da Covid, presos enviam cartas de amor e despedida',
    image: require('@/assets/images/cartas1.jpeg'),
    descricao: '',
    data: '30/04/2020',
    link: 'https://www.geledes.org.br/apavorado-com--o-risco-da-covid-presos-enviam-cartas-de-amor-e-despedida/',
  },
  {
    id: 2,
    palavra: 'Container',
    classe: 'container',
    manchete:
      'Ministério da Justiça e Sergio Moro recomenda uso de container para colocar presos que estão no grupo de risco e contaminados.',
    image: require('@/assets/images/publi1.jpg'),
    descricao: '',
    data: '21/04/2020',
    link: 'https://g1.globo.com/politica/noticia/2020/04/28/depen-propoe-que-presos-sejam-isolados-em-conteineres-por-causa-do-coronavirus.ghtml',
  },
  {
    id: 3,
    palavra: 'contaminados',
    classe: 'contaminados',
    manchete:
      'Ministério da Justiça e Sergio Moro recomenda uso de container para colocar presos que estão no grupo de risco e contaminados.',
    image: require('@/assets/images/publi1.jpg'),
    descricao: '',
    data: '21/04/2020',
    link: 'https://g1.globo.com/politica/noticia/2020/04/28/depen-propoe-que-presos-sejam-isolados-em-conteineres-por-causa-do-coronavirus.ghtml',
  },
  {
    id: 4,
    palavra: '“Um buraco no coração”',
    classe: 'um-buraco-no-coracao',
    manchete: '“Um buraco no coração”',
    descricao: 'Diz viúva de preso morto por Covid-19 que não conseguiu se despedir',
    link: 'https://ponte.org/um-buraco-no-coracao-diz-viuva-de-preso-morto-por-covid-19-que-nao-conseguiu-se-despedir/?fbclid=IwAR2-efqR_tMjG7zlpS7NGP707t9EoJbi5q0HftF3tSze10RZSDkzR69ME-k',
    data: '09/12/2021',
  },
  {
    id: 5,
    palavra: 'Sem visitas',
    classe: 'sem-visitas',
    manchete: 'Sem visitas nem acesso a advogados, presos temem coronavírus. Primeira vítima morre em cadeia do Rio',
    descricao:
      'Já são ao menos 54 internos com a covid-19 confirmada. Para membro da OAB, sem advogados e defensores indo ao presídio denúncias de tortura e sobre pandemia não são tornadas públicas',
    link: 'https://brasil.elpais.com/brasil/2020-04-17/sem-visitas-nem-acesso-a-advogados-presos-temem-coronavirus-primeira-vitima-morre-em-cadeia-do-rio.html',
    data: '17/04/2020',
  },
  {
    id: 6,
    palavra: 'denuncia tortura',
    classe: 'denuncia-tortura',
    manchete: 'Sem visitas nem acesso a advogados, presos temem coronavírus. Primeira vítima morre em cadeia do Rio',
    descricao:
      'Já são ao menos 54 internos com a covid-19 confirmada. Para membro da OAB, sem advogados e defensores indo ao presídio denúncias de tortura e sobre pandemia não são tornadas públicas',
    link: 'https://brasil.elpais.com/brasil/2020-04-17/sem-visitas-nem-acesso-a-advogados-presos-temem-coronavirus-primeira-vitima-morre-em-cadeia-do-rio.html',
    data: '17/04/2020',
  },
  {
    id: 7,
    palavra: 'Estrutura modular',
    classe: 'estrutura-modular',
    manchete: 'Covid19: Depen sugere contêineres para separar presos com sintomas.',
    descricao: 'Uso de estrutura modular temporária precisa da autorização do CNPC',
    link: 'https://agenciabrasil.ebc.com.br/geral/noticia/2020-04/covid-19-depen-sugere-conteineres-para-separar-presos-com-sintomas',
    data: '20/04/2020',
  },
  {
    id: 8,
    palavra: 'temporária',
    classe: 'temporaria',
    manchete: 'Covid19: Depen sugere contêineres para separar presos com sintomas.',
    descricao: 'Uso de estrutura modular temporária precisa da autorização do CNPC',
    link: 'https://agenciabrasil.ebc.com.br/geral/noticia/2020-04/covid-19-depen-sugere-conteineres-para-separar-presos-com-sintomas',
    data: '20/04/2020',
  },
  {
    id: 9,
    palavra: 'Sem ar',
    classe: 'sem-ar',
    manchete: 'Em contêiner, presos podem morrer sem ar, de calor ou por covid-19',
    descricao:
      'Considerada ilegal e inconstitucional desde 2010, medida criada para isolar detentos de grupos de risco do novo coronavírus será votado por Conselho',
    link: 'https://noticias.r7.com/brasil/em-conteiner-presos-podem-morrer-sem-ar-de-calor-ou-por-covid-19-06052020',
    data: '06/05/2020',
  },
  {
    id: 10,
    palavra: 'Sem ar',
    classe: 'sem-ar-2',
    manchete: 'Em contêiner, presos podem morrer sem ar, de calor ou por covid-19',
    descricao:
      'Considerada ilegal e inconstitucional desde 2010, medida criada para isolar detentos de grupos de risco do novo coronavírus será votado por Conselho',
    link: 'https://noticias.r7.com/brasil/em-conteiner-presos-podem-morrer-sem-ar-de-calor-ou-por-covid-19-06052020',
    data: '06/05/2020',
  },
  {
    id: 11,
    palavra: 'inconstitucional',
    classe: 'inconstitucional',
    manchete: 'Em contêiner, presos podem morrer sem ar, de calor ou por covid-19',
    descricao:
      'Considerada ilegal e inconstitucional desde 2010, medida criada para isolar detentos de grupos de risco do novo coronavírus será votado por Conselho',
    link: 'https://noticias.r7.com/brasil/em-conteiner-presos-podem-morrer-sem-ar-de-calor-ou-por-covid-19-06052020',
    data: '06/05/2020',
  },
  {
    id: 12,
    palavra: 'Direitos Humanos',
    classe: 'direitos-humanos',
    manchete: 'Comissão de Direitos Humanos da OEA critica contêineres...',
    descricao: 'Para presos na pandemia e cobra explicações do governo brasileiro',
    link: 'https://oglobo.globo.com/sociedade/comissao-de-direitos-humanos-da-oea-critica-conteineres-para-presos-na-pandemia-cobra-explicacao-do-governo-brasileiro-24412859',
    data: '06/05/2020',
  },
  {
    id: 13,
    palavra: 'explicações',
    classe: 'explicacoes',
    manchete: 'Comissão de Direitos Humanos da OEA critica contêineres...',
    descricao: 'Para presos na pandemia e cobra explicações do governo brasileiro',
    link: 'https://oglobo.globo.com/sociedade/comissao-de-direitos-humanos-da-oea-critica-conteineres-para-presos-na-pandemia-cobra-explicacao-do-governo-brasileiro-24412859',
    data: '06/05/2020',
  },
  {
    id: 14,
    palavra: 'alojar',
    classe: 'alojar',
    manchete: 'DEPEN sugere alojar em containers presos e idosos com suspeita de COVID-19',
    descricao: '',
    link: 'https://jornalistaslivres.org/depen-sugere-alojar-em-conteiners-presos-e-idosos-com-suspeita-de-covid-19/',
    data: '09/05/2020',
  },
  {
    id: 15,
    palavra: 'alojar',
    classe: 'alojar-2',
    manchete: 'DEPEN sugere alojar em containers presos e idosos com suspeita de COVID-19',
    descricao: '',
    link: 'https://jornalistaslivres.org/depen-sugere-alojar-em-conteiners-presos-e-idosos-com-suspeita-de-covid-19/',
    data: '09/05/2020',
  },
  {
    id: 16,
    palavra: 'idosos',
    classe: 'idosos',
    manchete: 'DEPEN sugere alojar em containers presos e idosos com suspeita de COVID-19',
    descricao: '',
    link: 'https://jornalistaslivres.org/depen-sugere-alojar-em-conteiners-presos-e-idosos-com-suspeita-de-covid-19/',
    data: '09/05/2020',
  },
  {
    id: 17,
    palavra: 'idosos',
    classe: 'idosos-2',
    manchete: 'DEPEN sugere alojar em containers presos e idosos com suspeita de COVID-19',
    descricao: '',
    link: 'https://jornalistaslivres.org/depen-sugere-alojar-em-conteiners-presos-e-idosos-com-suspeita-de-covid-19/',
    data: '09/05/2020',
  },
  {
    id: 18,
    palavra: 'idosos',
    classe: 'idosos-3',
    manchete: 'DEPEN sugere alojar em containers presos e idosos com suspeita de COVID-19',
    descricao: '',
    link: 'https://jornalistaslivres.org/depen-sugere-alojar-em-conteiners-presos-e-idosos-com-suspeita-de-covid-19/',
    data: '09/05/2020',
  },
  {
    id: 19,
    palavra: 'Fundação Casa',
    classe: 'fundacao-casa',
    manchete: '"Meu filho ligou dizendo que estava com falta de ar"',
    descricao: 'Diz mãe de adolescente internado na Fundação Casa',
    link: 'https://ponte.org/meu-filho-ligou-dizendo-que-estava-com-falta-de-ar-diz-mae-de-adolescente-internado-na-fundacao-casa/',
    data: '09/12/2020',
  },
  {
    id: 20,
    palavra: 'adolescentes',
    classe: 'adolescentes',
    manchete: '"Meu filho ligou dizendo que estava com falta de ar"',
    descricao: 'Diz mãe de adolescente internado na Fundação Casa',
    link: 'https://ponte.org/meu-filho-ligou-dizendo-que-estava-com-falta-de-ar-diz-mae-de-adolescente-internado-na-fundacao-casa/',
    data: '09/12/2020',
  },
  {
    id: 21,
    palavra: 'Amor',
    classe: 'amor-2',
    manchete: 'Apavorado”: com o risco da Covid, presos enviam cartas de amor e despedida',
    descricao: '',
    link: 'https://www.geledes.org.br/apavorado-com--o-risco-da-covid-presos-enviam-cartas-de-amor-e-despedida/',
    data: '30/04/2020',
  },
  {
    id: 22,
    palavra: 'despedida',
    classe: 'despedida-2',
    manchete: 'Apavorado”: com o risco da Covid, presos enviam cartas de amor e despedida',
    descricao: '',
    link: 'https://www.geledes.org.br/apavorado-com--o-risco-da-covid-presos-enviam-cartas-de-amor-e-despedida/',
    data: '30/04/2020',
  },
  {
    id: 23,
    palavra: 'Falta de informação',
    classe: 'falta-de-informacao',
    manchete: 'Falta de informação sobre pandemia aproxima Brasil a países autoritários',
    descricao:
      'As manobras do governo brasileiro para dificultar o acesso à informação relativa aos casos de covid-19 no Brasil aproximaram o Planalto às práticas de censura registradas em outras partes do mundo e a alguns dos regimes mais autoritários do mundo.',
    link: 'https://noticias.uol.com.br/colunas/jamil-chade/2020/06/07/bolsonaro-coloca-brasil-entre-paises-que-dificultam-dados-sobre-pandemia.htm',
    data: '07/06/2020',
  },
  {
    id: 24,
    palavra: 'países autoritários',
    classe: 'paises-autoritarios',
    manchete: 'Falta de informação sobre pandemia aproxima Brasil a países autoritários',
    descricao:
      'As manobras do governo brasileiro para dificultar o acesso à informação relativa aos casos de covid-19 no Brasil aproximaram o Planalto às práticas de censura registradas em outras partes do mundo e a alguns dos regimes mais autoritários do mundo.',
    link: 'https://noticias.uol.com.br/colunas/jamil-chade/2020/06/07/bolsonaro-coloca-brasil-entre-paises-que-dificultam-dados-sobre-pandemia.htm',
    data: '07/06/2020',
  },
  {
    id: 25,
    palavra: 'Painel da DEPEN',
    classe: 'painel-da-depen',
    manchete:
      'Há mais de seis meses, painel do DEPEN não atualiza informações sobre a Covid-19 no sistema prisional da Paraíba',
    descricao: '',
    link: 'https://www.covidnasprisoes.com/blog/painel-do-depen-nap-atualiza-informacoes-sobre-covid19-no-sistema-prisional-pb?categoryId=173484',
    data: '12/06/2021',
  },
  {
    id: 26,
    palavra: 'sistema prisional',
    classe: 'sistema-prisional',
    manchete:
      'Há mais de seis meses, painel do DEPEN não atualiza informações sobre a Covid-19 no sistema prisional da Paraíba',
    descricao: '',
    link: 'https://www.covidnasprisoes.com/blog/painel-do-depen-nap-atualiza-informacoes-sobre-covid19-no-sistema-prisional-pb?categoryId=173484',
    data: '12/06/2021',
  },
  {
    id: 27,
    palavra: 'Solitárias',
    classe: 'solitarias',
    manchete: 'Presídios: em vez de proteção, solitárias e granadas',
    descricao:
      'Governo nada gastou com EPIs contra covid-19. Mas impôs privação total de visitas e assistência jurídica, e tentou isolar contaminados em caixões de ferro. Agora, temendo provável convulsão, R$ 20 milhões com aparatos de repressão',
    link: 'https://outraspalavras.net/outrasmidias/presidios-em-vez-de-protecao-solitaria-e-granadas.',
    data: '08/07/2020',
  },
  {
    id: 28,
    palavra: 'caixões de ferro',
    classe: 'caixoes-de-ferro',
    manchete: 'Presídios: em vez de proteção, solitárias e granadas',
    descricao:
      'Governo nada gastou com EPIs contra covid-19. Mas impôs privação total de visitas e assistência jurídica, e tentou isolar contaminados em caixões de ferro. Agora, temendo provável convulsão, R$ 20 milhões com aparatos de repressão',
    link: 'https://outraspalavras.net/outrasmidias/presidios-em-vez-de-protecao-solitaria-e-granadas.',
    data: '08/07/2020',
  },
  {
    id: 29,
    palavra: 'Contaminação em massa',
    classe: 'contaminao-em-massa',
    manchete: '"É um pedido de socorro": detenta relata situação precária e casos confirmados em presídio de Goiás',
    descricao:
      'Carta de internas relatam contaminação em massa nas unidades, falta de acesso a materiais básicos de higiene, refeições estragadas.',
    link: 'https://www.instagram.com/p/CC9taqgnNTh',
    data: '22/07/2020',
  },
  {
    id: 30,
    palavra: 'refeições estragadas',
    classe: 'refeicoes-estragadas',
    manchete: '"É um pedido de socorro": detenta relata situação precária e casos confirmados em presídio de Goiás',
    descricao:
      'Carta de internas relatam contaminação em massa nas unidades, falta de acesso a materiais básicos de higiene, refeições estragadas.',
    link: 'https://www.instagram.com/p/CC9taqgnNTh',
    data: '22/07/2020',
  },
]

export const noticias3 = [
  {
    id: 0,
    palavra: 'Contágio',
    classe: 'contagio',
    manchete: 'Site do CNJ, com os últimos boletins de contágio e mortes.',
    descricao:
      'Monitoramento quinzenal dos casos de contágios e mortes por Covid-19 nos sistemas prisional e socioeducativo, categorizados entre servidores e pessoas em privação de liberdade.',
    link: 'https://www.cnj.jus.br/sistema-carcerario/covid-19/registros-de-contagios-obitos/',
    data: '09/12/2021',
  },
  {
    id: 0,
    palavra: 'mortes',
    classe: 'mortes',
    manchete: 'Site do CNJ, com os últimos boletins de contágio e mortes.',
    descricao:
      'Monitoramento quinzenal dos casos de contágios e mortes por Covid-19 nos sistemas prisional e socioeducativo, categorizados entre servidores e pessoas em privação de liberdade.',
    link: 'https://www.cnj.jus.br/sistema-carcerario/covid-19/registros-de-contagios-obitos/',
    data: '09/12/2021',
  },
  {
    id: 0,
    palavra: 'mortes',
    classe: 'mortes-2',
    manchete: 'Site do CNJ, com os últimos boletins de contágio e mortes.',
    descricao:
      'Monitoramento quinzenal dos casos de contágios e mortes por Covid-19 nos sistemas prisional e socioeducativo, categorizados entre servidores e pessoas em privação de liberdade.',
    link: 'https://www.cnj.jus.br/sistema-carcerario/covid-19/registros-de-contagios-obitos/',
    data: '09/12/2021',
  },
  {
    id: 0,
    palavra: 'mortes',
    classe: 'mortes-3',
    manchete: 'Site do CNJ, com os últimos boletins de contágio e mortes.',
    descricao:
      'Monitoramento quinzenal dos casos de contágios e mortes por Covid-19 nos sistemas prisional e socioeducativo, categorizados entre servidores e pessoas em privação de liberdade.',
    link: 'https://www.cnj.jus.br/sistema-carcerario/covid-19/registros-de-contagios-obitos/',
    data: '09/12/2021',
  },
  {
    id: 1,
    palavra: 'Tribunal de Justiça',
    classe: 'tribunal-de-justica',
    manchete: 'Tribunal de Justiça de SP, determina a vacinação de toda a população prisional em até 15 dias.',
    link: 'https://www.instagram.com/p/CRr67mqHNrA/',
    link2:
      'https://www.cnnbrasil.com.br/saude/justica-de-sp-determina-vacinacao-contra-covid-19-de-presos-em-ate-15-dias/',
    descricao:
      'Presidente do Tribunal de Justiça de São Paulo (TJ-SP), Geraldo Francisco Pinheiro Franco, derrubou decisão liminar que determinou ao estado paulista que vacinasse todas as pessoas presas em até 15 dias',
    data: '',
  },
  {
    id: 1,
    palavra: 'decisão liminar',
    classe: 'decisao-liminar',
    manchete: 'Tribunal de Justiça de SP, determina a vacinação de toda a população prisional em até 15 dias.',
    link: 'https://www.instagram.com/p/CRr67mqHNrA/',
    link2:
      'https://www.cnnbrasil.com.br/saude/justica-de-sp-determina-vacinacao-contra-covid-19-de-presos-em-ate-15-dias/',
    descricao:
      'Presidente do Tribunal de Justiça de São Paulo (TJ-SP), Geraldo Francisco Pinheiro Franco, derrubou decisão liminar que determinou ao estado paulista que vacinasse todas as pessoas presas em até 15 dias',
    data: '',
  },
  {
    id: 2,
    palavra: 'Não priorizam',
    classe: 'nao-priorizam',
    manchete:
      'Estados não priorizam as pessoas privadas de liberdade para a vacinação, outros não informam em que etapa está a vacinação, aumento no número de óbitos.',
    descricao: '',
    link: 'https://www.instagram.com/p/CNTEqHTnjS4/',
    link2:
      'https://www.covidnasprisoes.com/blog/pelo-menos-nove-estados-nao-priorizam-pessoas-presas-nos-planos-de-vacinacao.amp',
    data: '05/04/2021',
  },
  {
    id: 2,
    palavra: 'pessoas privadas de liberdade',
    classe: 'pessoas-privadas-de-liberdade',
    manchete:
      'Estados não priorizam as pessoas privadas de liberdade para a vacinação, outros não informam em que etapa está a vacinação, aumento no número de óbitos.',
    descricao: '',
    link: 'https://www.instagram.com/p/CNTEqHTnjS4/',
    link2:
      'https://www.covidnasprisoes.com/blog/pelo-menos-nove-estados-nao-priorizam-pessoas-presas-nos-planos-de-vacinacao.amp',
    data: '05/04/2021',
  },
  {
    id: 3,
    palavra: 'Plano de vacinação',
    classe: 'plano-de-vacinacao',
    manchete: 'São Paulo não segue plano de vacinação para a população prisional, divergência entre o PNI e o PEI.',
    descricao:
      'Apesar de registrar o maior número de óbitos (72, segundo dados da Secretaria de Administração Penitenciária - SAP) e contaminações (14.811) por COVID-19 no país, a vacinação da população prisional do estado de São Paulo não segue o Plano Nacional de Imunização (PNI). O PNI estabelece prioridade para pessoas presas e servidores do sistema prisional – que começaram a ser vacinados em abril.',
    link: 'https://www.instagram.com/p/CRFXwDQnPK8/',
    link2:
      'https://www.covidnasprisoes.com/blog/vacinacao-de-pessoas-presas-em-sp-nao-e-priorizada-e-nao-segue-calendario',
    data: '08/07/2021',
  },
  {
    id: 3,
    palavra: 'divergência',
    classe: 'divergencia',
    manchete: 'São Paulo não segue plano de vacinação para a população prisional, divergência entre o PNI e o PEI.',
    descricao:
      'Apesar de registrar o maior número de óbitos (72, segundo dados da Secretaria de Administração Penitenciária - SAP) e contaminações (14.811) por COVID-19 no país, a vacinação da população prisional do estado de São Paulo não segue o Plano Nacional de Imunização (PNI). O PNI estabelece prioridade para pessoas presas e servidores do sistema prisional – que começaram a ser vacinados em abril.',
    link: 'https://www.instagram.com/p/CRFXwDQnPK8/',
    link2:
      'https://www.covidnasprisoes.com/blog/vacinacao-de-pessoas-presas-em-sp-nao-e-priorizada-e-nao-segue-calendario',
    data: '08/07/2021',
  },
  {
    id: 4,
    palavra: 'Metas de vacinação',
    classe: 'metas-de-vacinacao',
    manchete: 'Informe técnico nacional de vacinação da Covid-19 no Brasil. ',
    descricao: '',
    link: 'https://www.conasems.org.br/wp-content/uploads/2021/01/Informe_Tecnico_Vacina_COVID-19.pdf',
    data: '18/01/2021',
  },
  {
    id: 4,
    palavra: 'cronogramas',
    classe: 'cronogramas',
    manchete: 'Informe técnico nacional de vacinação da Covid-19 no Brasil.',
    descricao: '',
    link: 'https://www.conasems.org.br/wp-content/uploads/2021/01/Informe_Tecnico_Vacina_COVID-19.pdf',
    data: '18/01/2021',
  },
  {
    id: 5,
    palavra: 'Falta de testes',
    classe: 'falta-de-testes',
    manchete: 'Falha nos testes causa aumento das mortes.',
    descricao:
      'Amapá, Distrito Federal e Maranhão são os estados brasileiros que fizeram menos testes do tipo PCR para detectar Covid-19',
    link: 'https://www.cnnbrasil.com.br/saude/falhas-em-testagem-de-covid-19-contribuiram-para-mortes-no-brasil-diz-fiocruz/',
    data: '05/01/2021',
  },
  {
    id: 5,
    palavra: 'aumento das mortes',
    classe: 'aumento-das-mortes',
    manchete: 'Falha nos testes causa aumento das mortes.',
    descricao:
      'Amapá, Distrito Federal e Maranhão são os estados brasileiros que fizeram menos testes do tipo PCR para detectar Covid-19',
    link: 'https://www.cnnbrasil.com.br/saude/falhas-em-testagem-de-covid-19-contribuiram-para-mortes-no-brasil-diz-fiocruz/',
    data: '05/01/2021',
  },
  {
    id: 6,
    palavra: 'Socioeducativo',
    classe: 'socioeducativo',
    manchete:
      'Monitoramento de contágio pelo CNJ dentro do sistema prisional e no socioeducativo com registro de pessoas presas e agentes penitenciários',
    descricao: 'Dados sobre: vacinação, testagem e investimentos, produzidos até 15 de novembro de 2021',
    link: 'https://www.cnj.jus.br/wp-content/uploads/2021/11/monitoramento-cnj-gmfs-covid-19-151121.pdf',
    data: '09/12/2021',
  },
  {
    id: 6,
    palavra: 'agentes penitenciários',
    classe: 'agentes-penitenciarios',
    manchete:
      'Monitoramento de contágio pelo CNJ dentro do sistema prisional e no socioeducativo com registro de pessoas presas e agentes penitenciários',
    descricao: 'Dados sobre: vacinação, testagem e investimentos, produzidos até 15 de novembro de 2021',
    link: 'https://www.cnj.jus.br/wp-content/uploads/2021/11/monitoramento-cnj-gmfs-covid-19-151121.pdf',
    data: '09/12/2021',
  },
  {
    id: 7,
    palavra: '81% dos presos',
    classe: 'dos-presos',
    manchete: 'Covid-19: 81% dos presos do Rio recebem a primeira dose da vacina',
    descricao:
      'A vacinação contra a covid-19 atingiu, com a primeira dose, 81% da população carcerária do estado do Rio de Janeiro.',
    link: 'https://agenciabrasil.ebc.com.br/saude/noticia/2021-07/covid-19-81-dos-presos-do-rio-receberam-primeira-dose-da-vacina',
    data: '20/12/2021',
  },
  {
    id: 7,
    palavra: '1ª dose',
    classe: 'primeira-dose',
    manchete: 'Covid-19: 81% dos presos do Rio recebem a primeira dose da vacina',
    descricao:
      'A vacinação contra a covid-19 atingiu, com a primeira dose, 81% da população carcerária do estado do Rio de Janeiro.',
    link: 'https://agenciabrasil.ebc.com.br/saude/noticia/2021-07/covid-19-81-dos-presos-do-rio-receberam-primeira-dose-da-vacina',
    data: '20/12/2021',
  },
  {
    id: 7,
    palavra: '1ª dose',
    classe: 'primeira-dose-2',
    manchete: 'Covid-19: 81% dos presos do Rio recebem a primeira dose da vacina',
    descricao:
      'A vacinação contra a covid-19 atingiu, com a primeira dose, 81% da população carcerária do estado do Rio de Janeiro.',
    link: 'https://agenciabrasil.ebc.com.br/saude/noticia/2021-07/covid-19-81-dos-presos-do-rio-receberam-primeira-dose-da-vacina',
    data: '20/12/2021',
  },
  {
    id: 8,
    palavra: '1° Estado do país',
    classe: 'estado-do-pais',
    manchete: 'DF é o 1º estado do país a concluir a vacinação do sistema prisional',
    descricao:
      'Ao todo, 14.954 pessoas privadas de liberdade e cerca de 600 policiais penais receberam a dose única da vacina Janssen, disponibilizada pela Secretaria de Saúde (SES) na sétima e última fase de vacinação.',
    link: 'https://www.agenciabrasilia.df.gov.br/2021/07/25/df-e-o-1o-do-pais-a-concluir-a-vacinacao-no-sistema-prisional/',
    data: '20/12/2021',
  },
  {
    id: 9,
    palavra: 'vacinação',
    classe: 'vacinacao',
    manchete: 'Covid-19: Vacinação de pessoas presas nos estados varia entre zero e 95%',
    descricao:
      'Monitoramento realizado pelo Conselho Nacional de Justiça (CNJ) mostra que 248.501 pessoas nos sistemas prisional e socioeducativo já receberam ao menos uma dose da imunização contra Covid-19, considerando internos e servidores.',
    link: 'https://www.cnj.jus.br/covid-19-vacinacao-de-pessoas-presas-nos-estados-varia-entre-zero-e-95/',
    data: '20/12/2021',
  },
  {
    id: 10,
    palavra: '2ª dose',
    classe: 'segunda-dose',
    manchete: 'Menos de 1,4 mil presos tomaram a segunda dose da vacina da Covid-19',
    descricao:
      'Nas prisões estaduais brasileiras, ao todo 34.255 pessoas privadas de liberdade tomaram a primeira dose da vacina contra Covid-19 e 1.360, a segunda. Entre os servidores desses estabelecimentos, os números são 47.482 e 33.252, respectivamente.',
    link: 'https://www.conjur.com.br/2021-jun-30/14-mil-presos-tomaram-dose-vacina-covid',
    data: '20/12/2021',
  },
  {
    id: 10,
    palavra: 'vacina',
    classe: 'vacina',
    manchete: 'Menos de 1,4 mil presos tomaram a segunda dose da vacina da Covid-19',
    descricao:
      'Nas prisões estaduais brasileiras, ao todo 34.255 pessoas privadas de liberdade tomaram a primeira dose da vacina contra Covid-19 e 1.360, a segunda. Entre os servidores desses estabelecimentos, os números são 47.482 e 33.252, respectivamente.',
    link: 'https://www.conjur.com.br/2021-jun-30/14-mil-presos-tomaram-dose-vacina-covid',
    data: '20/12/2021',
  },
  {
    id: 10,
    palavra: 'vacina',
    classe: 'vacina-2',
    manchete: 'Menos de 1,4 mil presos tomaram a segunda dose da vacina da Covid-19',
    descricao:
      'Nas prisões estaduais brasileiras, ao todo 34.255 pessoas privadas de liberdade tomaram a primeira dose da vacina contra Covid-19 e 1.360, a segunda. Entre os servidores desses estabelecimentos, os números são 47.482 e 33.252, respectivamente.',
    link: 'https://www.conjur.com.br/2021-jun-30/14-mil-presos-tomaram-dose-vacina-covid',
    data: '20/12/2021',
  },
  {
    id: 10,
    palavra: 'vacina',
    classe: 'vacina-3',
    manchete: 'Menos de 1,4 mil presos tomaram a segunda dose da vacina da Covid-19',
    descricao:
      'Nas prisões estaduais brasileiras, ao todo 34.255 pessoas privadas de liberdade tomaram a primeira dose da vacina contra Covid-19 e 1.360, a segunda. Entre os servidores desses estabelecimentos, os números são 47.482 e 33.252, respectivamente.',
    link: 'https://www.conjur.com.br/2021-jun-30/14-mil-presos-tomaram-dose-vacina-covid',
    data: '20/12/2021',
  },
]
